import React from "react";
import { reportPost } from "../store/postsSlice";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { toast } from "react-toastify";

const ReportModal = ({ visible, onClose, postId, userId, onReport }) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.posts.loading);

  const reportOptions = [
    { id: 1, label: "Harassment" },
    { id: 2, label: "Inappropriate Content" },
    { id: 3, label: "Hate Speech" },
    { id: 4, label: "Violence" },
    { id: 5, label: "Spam" },
    { id: 6, label: "Misinformation" },
  ];

  const handleReport = async (reason) => {
    console.log(`Reporting post ${postId} reason: ${reason} userId: ${userId}`);
    try {
      await dispatch(reportPost({ postId, userId, reason })).unwrap();
      toast.success(
        "Report Submitted Successfully! Admin will review it within 24 hours.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
      onReport();
      onClose();
    } catch (error) {
      console.error("Failed to report post:", error);
      toast.error("Failed to report!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-950 w-80 rounded-lg p-5 text-white">
        {isLoading ? (
          <div className="flex flex-col items-center justify-center p-5">
            <svg
              className="animate-spin h-8 w-8 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span className="mt-2 text-base">Submitting Report...</span>
          </div>
        ) : (
          <>
            <h2 className="text-lg font-bold mb-4 text-center">Report Post</h2>
            {reportOptions.map((option) => (
              <button
                key={option.id}
                className="w-full py-3 border-b border-gray-700 text-base text-center hover:bg-gray-700 disabled:opacity-50"
                onClick={() => handleReport(option.label)}
                disabled={isLoading}
              >
                {option.label}
              </button>
            ))}
            <button
              className="w-full mt-4 py-3 text-base font-semibold text-center hover:bg-gray-700 disabled:opacity-50"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportModal;
